const SET_PRICE_SOURCE = 'settings/SET_PRICE_SOURCE'
const SET_SETTINGS = 'settings/SET_SETTINGS'

export const version = 4

export const initialState = {
  priceSources: ['cardkingdom', 'tcgplayer', 'cardhoarder'],
  saltLevel: 1,
  seenWarningMay2022: false,
  version,
}

const settings = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRICE_SOURCE:
      return {
        ...state,
        priceSources: [
          ...state.priceSources.slice(0, action.i),
          action.priceSource,
          ...state.priceSources.slice(action.i + 1),
        ],
      }
    case SET_SETTINGS:
      return {
        ...state,
        ...action.settings,
      }
    default:
      return state
  }
}

export const setSettings = (settings) => ({ settings, type: SET_SETTINGS })

export const setPriceSource = ({ i, priceSource }) => ({
  i,
  priceSource,
  type: SET_PRICE_SOURCE,
})

export default settings
